'use strict'

import JSZip from 'jszip'

export default class FileUtils {
  static setUtf8Bom (content) {
    return '\ufeff' + content
  }

  static download (name, content) {
    FileUtils.downloadBlob(name, new Blob([FileUtils.setUtf8Bom(content)]))
  }

  static downloadBlob (name, blob) {
    let link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = name
    link.click()
  }

  static downloadAsZip (name, files) {
    return new Promise((resolve, reject) => {
      let zip = new JSZip()
      files.map((file) => zip.file(file.name, FileUtils.setUtf8Bom(file.data)))
      zip.generateAsync({type:"blob"}).then((blob)=> {
        FileUtils.downloadBlob(`${name}.zip`, blob)
        resolve()
      }).catch(reject)
    })

  }
}
